import { z } from "zod";
import { RequestMagicLinkMethodSchema } from "../Enums/RequestMagicLinkMethod";

export const CreateMagicLinkInputSchema = z.object({
    requestId: z.string().uuid(),
    method: RequestMagicLinkMethodSchema,
    recipient: z.string(),
});

export type CreateMagicLinkInput = z.infer<typeof CreateMagicLinkInputSchema>;

